import { I18nSelector } from '../types';

const routes: [path: string, name: I18nSelector][] = [
	['/', i18n => i18n.topbar.home],
	['/how-it-works', i18n => i18n.topbar.howItWorks],
	['/distribution-stations', i18n => i18n.topbar.distStations],
	['/associations', i18n => i18n.topbar.associations],
	['/prices', i18n => i18n.topbar.prices],
	['/who-are-we', i18n => i18n.topbar.whoWeAre],
	['/common-questions', i18n => i18n.topbar.commonQs],
	['/contact-us', i18n => i18n.topbar.contact],
	['/profile', i18n => i18n.topbar.profile],
];

export default routes;